import axios from 'axios';
import { onResponseError } from './handle-response';
import TokenService from './auth/token.service';
import { encryptedPayloadData } from '../helper/utils';
import Cookies from 'js-cookie';

const axiosApiInstance = axios.create();

// Need to update when api is working
const apiPath =
  process.env.REACT_APP_ENV === 'production'
    ? process.env.REACT_APP_PROD_BASE_URL
    : process.env.REACT_APP_DEV_BASE_URL;

axiosApiInstance.interceptors.request.use(
  async (config: any) => {
    let token = null;

    // First try to get token from localStorage
    const localAccessToken = TokenService.getLocalAccessToken();
    const access_token = Cookies.get('access_token') || null;
    if (localAccessToken && !config.url?.includes('/token-refresh')) {
      // Use encrypted local token
      token = `Bearer ${encryptedPayloadData(localAccessToken, 'bearer')}`;
    } else if (access_token) {
      token = `Bearer ${access_token}`;
    } else {
      token = config.headers.Authorization;
    }

    // Set base URL based on apiVersion
    if (config?.apiVersion) {
      config.baseURL = `${apiPath}/${config.apiVersion}`;
    } else {
      config.baseURL = `${apiPath}/v1`;
    }

    // Set Authorization header
    if (token) {
      config.headers.Authorization = token;
    }

    console.log('Using token:', token);

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosApiInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => onResponseError(error)
);

export default axiosApiInstance;
